// extracted by mini-css-extract-plugin
export var actions = "_15-0";
export var actionsContainer = "_15-8";
export var border = "_15-1";
export var childFullHeight = "_15-f";
export var collapse = "_15-2";
export var content = "_15-a";
export var contentChild = "_15-e";
export var fullscreen = "_15-c";
export var hasLeftRadius = "_15-r";
export var headerContainer = "_15-3";
export var headerRow = "_15-5";
export var hidePadding = "_15-b";
export var navCollapsedGap = "_15-s";
export var noScrollX = "_15-t";
export var noScrollY = "_15-u";
export var noTopPadding = "_15-p";
export var optOutTopPadding = "_15-d";
export var outletContent = "_15-l";
export var outletContentInner = "_15-m";
export var outletLeadingPanel = "_15-i";
export var outletLeadingPanelAttention = "_15-j";
export var outletNoScroll = "_15-7";
export var outletResizeDivider = "_15-k";
export var outletSplit = "_15-g";
export var outletSplitResizing = "_15-h";
export var pageMain = "_15-q";
export var pageOuter = "_15-n";
export var pagePadding = "_15-9";
export var profile = "_15-v";
export var profileContainer = "_15-w";
export var profileImage = "_15-x";
export var profileMain = "_15-y";
export var profileSubtitle = "_15-10";
export var profileTitle = "_15-z";
export var showLeftPadding = "_15-o";
export var tabsPortalSlot = "_15-6";
export var tabsWrapper = "_15-4";
export var title = "_15-11";